function setupBookiliciousMotion(){
  const items=document.querySelectorAll('.premium-gift-card,.premium-section-head,.premium-editorial-copy,.premium-green-banner__copy,.cro-feature-card,.cro-story-copy,[data-refined-reveal]');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduced||!('IntersectionObserver' in window))return;
  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting){entry.target.classList.add('is-revealed');observer.unobserve(entry.target);}
    });
  },{threshold:0.08,rootMargin:'0px 0px 30px 0px'});
  items.forEach(item=>{
    if(item.dataset.motionBound)return;
    item.dataset.motionBound='true';
    item.classList.add('bookilicious-reveal');
    observer.observe(item);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupBookiliciousMotion);else setupBookiliciousMotion();
document.addEventListener('shopify:section:load',setupBookiliciousMotion);
